module.exports = __webpack_public_path__ + "img/search.47afe2e3.png";